<div class="data-table" *ngIf="decisionInput$ | async as decisionInput">
  <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <mat-label class="font-weight-bold field-required">{{ title | translate }} </mat-label>
  <ng-container *ngIf="dataSource$ | async as dataSource">
    <table mat-table [dataSource]="dataSource?.data">
      
      <ng-container *ngIf="enableEntityResponse;else showFilterData">
        <ng-container matColumnDef="summaryText">
          <th mat-header-cell *matHeaderCellDef>
            <strong> {{ "forms.common.Criteria.summary" | translate }}</strong>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="content">{{ row?.summaryText }}</div>
          </td>
        </ng-container>
      </ng-container>
      <ng-template #showFilterData>
        <ng-container matColumnDef="{{filter}}">
          <th mat-header-cell *matHeaderCellDef>
            <strong> {{ "forms.common.Criteria.summary" | translate }}</strong>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="content">{{ row[filter] }}</div>
          </td>
        </ng-container>
      </ng-template>

      <ng-container matColumnDef="criterionKey">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.MasarCriteria" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="d-inline-block font-weight-bold mx-1 px-2 py-1 chip">{{row.criterionKey}}</span>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="member">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.Member" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row | propertyLocalized : ["memberArabicName", "memberEnglishName"] | async}}</div>
        </td>
      </ng-container> -->

      <ng-container matColumnDef="finalReportResponse">
        <th mat-header-cell *matHeaderCellDef>
          <strong *ngIf="hasResponse"> {{ "forms.common.Criteria.finalReportResponse" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content response" *ngIf="row?.finalReportResponseId && hasResponse">
            {{ "forms.common.Criteria.finalReportResponseAdded" | translate }}
          </div>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="leaderDecision">
        <th mat-header-cell *matHeaderCellDef>
          <strong *ngIf="isLeaderDecision"> {{ "forms.common.Criteria.Decision" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content" *ngIf="row?.leaderDecision && isLeaderDecision">
            {{ "forms.common.Criteria." + row?.leaderDecision  | translate }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row;let i = index" style="width: 50px">
          <div class="d-flex justify-content-end">
            <ng-container
              *ngIf="!decisionInput.viewOnly && decisionInput.executeVisitType == institutionEntries && isRecommendations && !row?.finalReportResponseId">
              <button mat-icon-button (click)="showResponse(decisionInput,row)"
                matTooltip="{{ 'forms.common.Criteria.AddResponse' | translate }}">
                <mat-icon>add</mat-icon>
              </button>
            </ng-container>
            <ng-container
              *ngIf="row?.finalReportResponseId && ((decisionInput.viewOnly && decisionInput.executeVisitType == institutionEntries) || hasResponse)">
              <button mat-icon-button (click)="showResponse(decisionInput,row)"
                matTooltip="{{ 'forms.common.Criteria.ShowResponse' | translate }}">
                <mat-icon>rate_review</mat-icon>
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="noRecord">
        <td colspan="5" class="text-center" mat-footer-cell *matFooterCellDef>
          {{ "forms.common.No items added yet" | translate }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'deleted': row?.rejected}"></tr>

      <tr [hidden]="!!dataSource?.data?.length" mat-footer-row *matFooterRowDef="
      dataSource?.data?.length === 0 ? ['noRecord'] : []
      "></tr>
    </table>

    <mat-paginator *ngIf="dataSource?.totalItems" [length]="dataSource?.totalItems" [pageSize]="pageSize"
      (page)="changePage($event)">
    </mat-paginator>
  </ng-container>
</div>
<br />